import gql from "graphql-tag"
import type { TypedDocumentNode } from "@graphql-typed-document-node/core"

type OrderOperationEvent = {
  orderId: string
  type: string
}

type OnOrderOperationFailedSubscription = { OnOrderOperationFailed: OrderOperationEvent }

const ON_ORDER_OPERATION_FAILED: TypedDocumentNode<
  OnOrderOperationFailedSubscription,
  Record<string, never>
> = gql`
  subscription OnOrderOperationFailed {
    OnOrderOperationFailed {
      orderId
      type
    }
  }
`

export default ON_ORDER_OPERATION_FAILED
